export default class ModalPdfDataExtractedController {
	/* @ngInject */
	/**
	 * @param {import('angular').ui.bootstrap.IModalInstanceService} $uibModalInstance
	 * @param {any} propositions
	 */
	constructor($uibModalInstance, propositions) {
		this.$uibModalInstance = $uibModalInstance;
		this.propositions = propositions;
	}

	submit() {
		this.$uibModalInstance.close(this.propositions);
	}
}
